import styled, { css } from "styled-components";
import { colors } from "../../../../../../../../consts";
import { Paragraph2, WrapperContainer } from "../../../../../../../../components";

const FirstCircleStyle = css`
  padding-top: 4px;
  top: 0px;

  &:before {
    background: ${colors.RAISIN_50};
  }
`;

export const Circle = styled(WrapperContainer)`
  position: absolute;
  left: -4px;
  top: 2px;
  background: white;
  padding: 2px 0;

  ${(props) => props.isFirstRecord && FirstCircleStyle}

  &:before {
    content: "";
    display: block;
    width: 8px;
    height: 8px;
    min-height: 8px;
    box-sizing: border-box;

    border: 1px solid;
    border-color: ${colors.RAISIN_50};
    border-radius: 100%;
  }
`;

export const HistoryItemStyled = styled(WrapperContainer)`
  border-left: 1px solid;
  border-color: ${(props) => (props.isLastRecord ? colors.WHITE : colors.RAISIN_50)};

  padding-bottom: 8px;
  padding-left: 16px;
  position: relative;
  margin-left: 4px;

  ${(props) => props.isFirstRecord && "min-height: 54px"};

  &:last-of-type {
    padding-bottom: 0;
  }
`;

export const DateInfo = styled(Paragraph2)`
  font-size: 12px;
  line-height: 18px;

  color: ${colors.RAISIN_50} !important;
`;

export const ActionInfo = styled(Paragraph2)`
  color: ${colors.RAISIN_70};

  b {
    color: ${colors.RAISIN_100};
  }
`;
